/** A message about the view it sits in, with at most one action. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Banner.css";

export type BannerTone = "info" | "success" | "warning" | "danger";

export interface BannerProps {
  readonly tone?: BannerTone;
  readonly title?: ReactNode;
  readonly action?: ReactNode;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Banner({ tone = "info", title, action, className, style, children }: BannerProps) {
  const urgent = tone === "warning" || tone === "danger";
  return (
    <div
      role={urgent ? "alert" : "status"}
      className={cn("al-banner", `al-banner-${tone}`, className)}
      style={style}
    >
      <span className="al-banner-mark" aria-hidden="true" />
      <div className="al-banner-main">
        {title !== undefined ? <div className="al-banner-title">{title}</div> : null}
        {children !== undefined ? <div className="al-banner-body">{children}</div> : null}
      </div>
      {action !== undefined ? <div className="al-banner-action">{action}</div> : null}
    </div>
  );
}
